<template>
	<ul>
		<span v-if="!multiSelect">
			<li :class="isActive === option.name ? 'isActive' : ''" :key="i" v-for="(option, i) in options">
				<el-button @click="action(option)" type="text">{{ option.name }}</el-button>
			</li>
		</span>
		<span v-if="multiSelect">
			<li style="margin-bottom: 10px" :key="i + option.name" v-for="(option, i) in options">
				<el-checkbox
					@change="checkToggle"
					v-model="option.checked"
					:label="option.name"
					border
					size="small"
				></el-checkbox>
			</li>
		</span>
	</ul>
</template>

<script>
export default {
	props: {
		options: Array,
		multiSelect: Boolean,
	},
	data() {
		return {
			isActive: this.options ? this.options[0].name : null,
		};
	},
	methods: {
		checkToggle() {
			this.$emit(
				"event",
				this.options
					.filter((each) => {
						return each.checked;
					})
					.map((each) => {
						return each.alias ? each.alias : each.name;
					})
			);
		},
		action(option) {
			if (this.isActive === option.name) {
				return;
			}
			this.isActive = option.name;
			this.$emit("event", this.isActive);
		},
	},
};
</script>

<style scoped>
ul {
	margin: 0;
	list-style-type: none;
	padding: 0;
}

.isActive {
	background-color: #210f3c;
	border-radius: 4px;
	max-width: 150px;
	text-align: center;
}

.isActive /deep/ span {
	color: white !important;
}
</style>
